import { COLORS } from '@btime/constants'
import React from 'react'

import { Text } from '../../components/presentation/Text'
import { useHelpActions } from '../../utils/contexts/HelpProvider'
import Link from '../../components/actions/Link'
import { useTranslation } from 'react-i18next'

const HelpTextLauncher = () => {
  const { t } = useTranslation('help')
  const { openPrimaryHelpOption } = useHelpActions()

  return (
    <Link onClick={openPrimaryHelpOption}>
      <Text color={COLORS.dark3}>
        {t('needHelp')} <span style={{ color: COLORS.purple }}>{t('talkToBtime')}</span>
      </Text>
    </Link>
  )
}

export default HelpTextLauncher
